<template>
  <!-- my profile screen, shows the data of the logged in user and possible edits -->

  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="CopyCodePaymentModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content" style="opacity: 0.9">
        <div class="modal-header" style="border: none">
          <button
            type="button"
            class="close"
            id="closeCopyCodeModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" style="font-size: 35px; cursor: pointer"
              >&times;</span
            >
          </button>
        </div>
        <div class="modal-body">
          <div class="col-12" style="display: flex; margin-top: -55px">
            <div class="col col-width col-ipad">
              <div class="loading_pix" v-if="!this.codeBill">
                <img
                  src="https://cdn.dribbble.com/users/1187836/screenshots/5979585/dribbble.gif"
                  alt="copyCodeBill"
                />
              </div>
              <div v-else>
                <span style="font-size: 8px"> {{ this.codeBill }}</span>
                <div style="display: flex; justify-content: center">
                  <button
                    type="button"
                    id="copyCodeLine"
                    class="btn access"
                    @click="copyCode()"
                  >
                    Copiar linha digitável
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import BillsAction from "./BillsAction";

export default {
  name: "CopyCodeModal",
  data() {
    return {
      codeBill: false,
    };
  },
  props: ["bill"],

  methods: {
    copyCode: function () {
      if (this.codeBill) {
        return BillsAction.copy(this.codeBill);
      }
    },
  },
  mounted() {
    $("#CopyCodePaymentModal").modal("show");
    BillsAction.getCodeBills(this.bill.cod_id).then((response) => {
      this.codeBill = response;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loading_pix {
  width: 200px;
  height: 150px;
  overflow: hidden;
}

.loading_pix img {
  margin: -252px 0 0 -303px;
}
.col-width {
  display: flex;
  justify-content: center;
}
.modal-dialog {
  margin-top: 100%;
  width: 100%;
  margin-left: 0px;
}
.space-style {
  margin-top: 30%;
}
.access {
  color: #fff;
  width: 60%;
  height: 100%;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  margin-right: 25px;
  margin-top: 5px;
}

.text-align-center {
  color: rgb(100, 95, 95);
  font-size: 14px;
}

@media only screen and (max-width: 790px) and (min-width: 700px) {
  .modal-content {
    width: 154%;
  }
  .col-ipad {
    display: flex;
    justify-content: center;
  }

  .space-style {
    margin-top: 15%;
  }
}
@media only screen and (max-width: 900px) and (min-width: 790px) {
  .modal-content {
    width: 160%;
  }
  .space-style {
    margin-top: 15%;
  }
  .col-ipad {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/home/bill/CopyCodeModal.vue